/* PYRATES TCG — Treasure Vault v6.0 */

let enteredCipher = [];
const MAX_CIPHER_LENGTH = 7; // TEST111 has 7 characters. Change to 10 later.

const SUPABASE_URL = "https://jxsdiqimtnjrtyvndkxn.supabase.co";
const SUPABASE_KEY = "sb_publishable_douHHIrgd7PQsSxn7eX9VQ__u-Cs_gp";

const GLYPH_BASE_URL =
  "https://cdn.shopify.com/s/files/1/0777/4909/2588/files/";

const cipherGlyphs = [
  { value: "A", file: "cipher-01.png", name: "Skull & Sabers" },
  { value: "B", file: "cipher-02.png", name: "Anchor" },
  { value: "C", file: "cipher-03.png", name: "Compass Rose" },
  { value: "D", file: "cipher-04.png", name: "Crescent Moon" },
  { value: "E", file: "cipher-05.png", name: "Sextant" },
  { value: "F", file: "cipher-06.png", name: "Crystal Diamond" },
  { value: "G", file: "cipher-07.png", name: "Great Wave" },
  { value: "H", file: "cipher-08.png", name: "North Star" },
  { value: "I", file: "cipher-09.png", name: "Lighthouse" },
  { value: "J", file: "cipher-10.png", name: "Fortress" },
  { value: "K", file: "cipher-11.png", name: "Trident" },
  { value: "L", file: "cipher-12.png", name: "Crossed Blades" },
  { value: "M", file: "cipher-13.png", name: "Warship" },
  { value: "N", file: "cipher-14.png", name: "Ship's Wheel" },
  { value: "O", file: "cipher-15.png", name: "Solar Compass" },
  { value: "P", file: "cipher-16.png", name: "Obelisk" },
  { value: "Q", file: "cipher-17.png", name: "Rune Diamond" },
  { value: "R", file: "cipher-18.png", name: "Watcher's Eye" },
  { value: "S", file: "cipher-19.png", name: "Wind Banner" },
  { value: "T", file: "cipher-20.png", name: "Target Ring" },
  { value: "U", file: "cipher-21.png", name: "Sacred Covenant" },
  { value: "V", file: "cipher-22.png", name: "Abyss Triangle" },
  { value: "W", file: "cipher-23.png", name: "Ascendant Triangle" },
  { value: "X", file: "cipher-24.png", name: "Orb of Fate" },
  { value: "Y", file: "cipher-25.png", name: "Phoenix Feather" },
  { value: "Z", file: "cipher-26.png", name: "Crowned Helm" },
  { value: "0", file: "cipher-27.png", name: "Treasure Chest" },
  { value: "1", file: "cipher-28.png", name: "Treasure Key" },
  { value: "2", file: "cipher-29.png", name: "Coin of Fortune" },
  { value: "3", file: "cipher-30.png", name: "Royal Crown" },
  { value: "4", file: "cipher-31.png", name: "Jewel of the Abyss" },
  { value: "5", file: "cipher-32.png", name: "Treasure Map" },
  { value: "6", file: "cipher-33.png", name: "Founders' Seal" },
  { value: "7", file: "cipher-34.png", name: "Pyrates Sigil" }
];

const glyphSlots = [
  { x: 40, y: 20 }, { x: 160, y: 20 }, { x: 280, y: 20 }, { x: 400, y: 20 }, { x: 520, y: 20 }, { x: 640, y: 20 }, { x: 760, y: 20 },
  { x: 40, y: 135 }, { x: 160, y: 135 }, { x: 280, y: 135 }, { x: 400, y: 135 }, { x: 520, y: 135 }, { x: 640, y: 135 }, { x: 760, y: 135 },
  { x: 40, y: 250 }, { x: 160, y: 250 }, { x: 280, y: 250 }, { x: 400, y: 250 }, { x: 520, y: 250 }, { x: 640, y: 250 }, { x: 760, y: 250 },
  { x: 40, y: 365 }, { x: 160, y: 365 }, { x: 280, y: 365 }, { x: 400, y: 365 }, { x: 520, y: 365 }, { x: 640, y: 365 }, { x: 760, y: 365 },
  { x: 100, y: 480 }, { x: 220, y: 480 }, { x: 340, y: 480 }, { x: 460, y: 480 }, { x: 580, y: 480 }, { x: 700, y: 480 }
];

let supabaseClient = null;

document.addEventListener("DOMContentLoaded", function () {
  const keyboard = document.getElementById("cipherKeyboard");
  const display = document.getElementById("cipherDisplay");
  const backspaceBtn = document.getElementById("backspaceBtn");
  const clearBtn = document.getElementById("clearBtn");
  const redeemBtn = document.getElementById("redeemBtn");

  if (!keyboard || !display) return;

  if (window.supabase) {
    supabaseClient = window.supabase.createClient(SUPABASE_URL, SUPABASE_KEY);
  }

  keyboard.innerHTML = "";
  enteredCipher = [];

  shuffleArray([...cipherGlyphs]).forEach(function (glyph, index) {
    const slot = glyphSlots[index];

    const button = document.createElement("button");
    button.type = "button";
    button.className = "cipher-key";
    button.title = glyph.name;
    button.style.left = slot.x + "px";
    button.style.top = slot.y + "px";

    const img = document.createElement("img");
    img.src = GLYPH_BASE_URL + glyph.file;
    img.alt = glyph.name;
    img.loading = "lazy";

    button.appendChild(img);

    button.addEventListener("click", function () {
      if (enteredCipher.length >= MAX_CIPHER_LENGTH) {
        setStatus("Maximum Cipher Length Reached");
        return;
      }

      enteredCipher.push(glyph);
      updateDisplay(display);
      updateStatus();
    });

    keyboard.appendChild(button);
  });

  updateDisplay(display);
  setStatus("Awaiting Ancient Cipher...");

  backspaceBtn?.addEventListener("click", function () {
    enteredCipher.pop();
    updateDisplay(display);
    updateStatus();
  });

  clearBtn?.addEventListener("click", function () {
    resetVault(display);
  });

  redeemBtn?.addEventListener("click", async function () {
    if (enteredCipher.length < MAX_CIPHER_LENGTH) {
      setStatus(`${enteredCipher.length} of ${MAX_CIPHER_LENGTH} Glyphs Entered`);
      return;
    }

    const enteredCode = enteredCipher.map(glyph => glyph.value).join("");

    if (!supabaseClient) {
      setStatus("Supabase Not Connected");
      return;
    }

    setStatus("Verifying Treasure...");

    const { data, error } = await supabaseClient
      .from("treasure_codes")
      .select("*")
      .eq("code", enteredCode)
      .single();

    if (error || !data) {
      setStatus("Invalid Cipher");
      return;
    }

    if (data.redeemed === true) {
      showRewardReveal(
        "TREASURE ALREADY CLAIMED",
        data.reward_name || "Unknown Treasure",
        data.reward_type || "Pyrates Treasure Series",
        false
      );
      return;
    }

    const { error: updateError } = await supabaseClient
      .from("treasure_codes")
      .update({
        redeemed: true,
        redeemed_at: new Date().toISOString()
      })
      .eq("id", data.id);

    if (updateError) {
      setStatus("Treasure Found, But Claim Failed");
      return;
    }

    showRewardReveal(
      "TREASURE UNLOCKED",
      data.reward_name || "Unknown Treasure",
      data.reward_type || "Pyrates Treasure Series",
      true
    );
  });
});

function updateDisplay(display) {
  display.innerHTML = "";

  enteredCipher.forEach(function (glyph) {
    const img = document.createElement("img");
    img.src = GLYPH_BASE_URL + glyph.file;
    img.alt = glyph.name;
    img.className = "display-glyph";
    display.appendChild(img);
  });
}

function updateStatus() {
  if (enteredCipher.length === 0) {
    setStatus("Awaiting Ancient Cipher...");
  } else if (enteredCipher.length >= MAX_CIPHER_LENGTH) {
    setStatus("Ready to Verify Treasure");
  } else {
    setStatus(`${enteredCipher.length} of ${MAX_CIPHER_LENGTH} Glyphs Entered`);
  }
}

function setStatus(text) {
  const panel = document.getElementById("vaultStatusPanel");
  if (!panel) return;
  panel.textContent = text;
}

function showRewardReveal(title, rewardName, rewardSeries, success) {
  const reveal = document.getElementById("rewardReveal");
  const rewardTitleEl = document.getElementById("rewardTitle");
  const rewardNameEl = document.getElementById("rewardName");
  const rewardSeriesEl = document.getElementById("rewardSeries");
  const continueBtn = document.getElementById("continueBtn");

  if (!reveal) {
    setStatus(`${title}: ${rewardName}`);
    return;
  }

  if (rewardTitleEl) rewardTitleEl.textContent = title;
  if (rewardNameEl) rewardNameEl.textContent = rewardName;
  if (rewardSeriesEl) rewardSeriesEl.textContent = rewardSeries;

  reveal.classList.remove("hidden");

  if (success) {
    setStatus("Treasure Unlocked");
  } else {
    setStatus("Treasure Already Claimed");
  }

  if (continueBtn) {
    continueBtn.onclick = function () {
      reveal.classList.add("hidden");
      const display = document.getElementById("cipherDisplay");
      resetVault(display);
    };
  }
}

function resetVault(display) {
  enteredCipher = [];
  if (display) updateDisplay(display);
  setStatus("Awaiting Ancient Cipher...");
}

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}